// KÁRTYA-SOR LISTA — a kezdőlap (és bármely kártya) sor-listájának EGY közös alakja.
//
// MIÉRT KELL (user-döntés): a kártyák sorai `divide-y`-jal készültek, ami a vonalat a kártya
// SZÉLÉIG futtatja — a lista-táblánk viszont BEHÚZOTT hajszálvonalat használ (`DataTable`: `after:inset-x-3`).
// Így ugyanaz a „sorok egymás alatt" minta két különböző vonalat adott a felületen. Ez a molekula a
// LISTA-KONVENCIÓT hozza a kártyákba: behúzott, halvány (`--table-hairline`) vonal, az UTOLSÓ sor alatt nincs.
//
// A vonal a soron PSZEUDÓ-ELEM (nem `border-b`), mert így nem tolja el a sor magasságát, és a behúzás a sor
// paddingjéhez igazítható — pontosan úgy, ahogy a `DataTable` sorai teszik.
import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Sor-lista egy kártyában (`ul`) — a sorokat `CardRow` adja. */
export function CardRows({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return <ul className={cn('flex flex-col', className)}>{children}</ul>;
}

/**
 * Egy kártya-sor (`li`) BEHÚZOTT hajszálvonallal az alján; az utolsó sor alatt a vonal eltűnik
 * (`last:after:hidden`), tehát a lista alja nem kap „lezáró" vonalat.
 */
export function CardRow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <li
      className={cn(
        "relative after:pointer-events-none after:absolute after:inset-x-3 after:bottom-0 after:h-px after:bg-[color:var(--table-hairline)] after:content-[''] last:after:hidden",
        className,
      )}
    >
      {children}
    </li>
  );
}
